<template>
  <div>

                        <div v-show="dialog" class='popContainer' @@click="hideDialog">
                          <img src="" alt="">
                        <div style="margin-top: -650px;">
                            <span class="popContainerText">
                                请在右上角选择用浏览器打开！
                            </span>
                        </div>
                    </div>

  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      android: {
        role: "store",
        platform: "aphone",
      },
      dialog:false,
    };
  },
  created() {},
  mounted() {
    console.log(this.isMobile());
    if (!this.isMobile()) {
      this.$toast("    请使用手机扫码下载！   ");
    } else {
      this.openJoin();
    }
  },
  methods: {
    // 微信背景灰色板
    hideDialog() {
           this.dialog = true;
       },

  // 判断手机端
    openJoin() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var isWeixin = u.indexOf('MicroMessenger')
      
      if( isWeixin> -1){
        if (isiOS) {
      window.location.href ="https://apps.apple.com/cn/app/6448017713";
      }else{
        this.hideDialog()
      }
      }else{
        if (isAndroid) {
      axios.post('https://invinciblebackstage.df-js.cn/api/application/findLatestByRoleAndPlatform',this.android).then(resp=>{
        window.location.href = resp.data.data.url;
      })
      }
      if (isiOS) {
      window.location.href ="https://apps.apple.com/cn/app/6448017713";
      }
      }
      

     
    },
    isMobile() {
      let flag = window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|WebOS|Symbian|Windows Phone)/i
      );
      return flag ? true : false;
    },
  },
};
</script>
  
<style scoped>

        .popContainer {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            z-index: 999;
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            background: #000000;
            opacity: 0.9;
        }
            /* .popContainer img {
                z-index:999;
                width: 480px;
                height: 367px;
            } */

        .popContainerText {
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
           
        }


</style>



// WEBPACK FOOTER //
// src/components/businessDown.vue